import { useEffect } from 'react';
import { findLast } from 'lodash';
import isNil from 'lodash/isNil';
import makeStyles from '@mui/styles/makeStyles';
import usePage from '@monorepo/shared/src/hooks/use-page';
import { getTotalPages } from '@monorepo/shared/src/util/paging-util';
import { AppRoutes, DEFAULT_FIRST_PAGE, PageTypes } from '../types';

const useLetterTeaching = (book: any, hasCover: boolean) => {
  const routes: string[] = [
    `/${AppRoutes.TEACHERS_GUIDE}`,
    `/${AppRoutes.LETTER_BOOK}`,
    `/${AppRoutes.STUDENT_PRACTICE_BOOK}`,
  ];

  const [{ currentPage }, { setNumberOfTotalPages, getCurrentPageData, resetPage, setFirstPage }] =
    usePage();

  const classes = useStyles();

  useEffect(() => {
    resetPage();
  }, []);

  useEffect(() => {
    const firstPage = book?.pages.find(({ pageNumber }) => !isNil(pageNumber))?.pageNumber;
    const lastPage = findLast(book?.pages, ({ pageNumber }) => !isNil(pageNumber))?.pageNumber;

    firstPage && setFirstPage(hasCover ? DEFAULT_FIRST_PAGE[PageTypes.Pdf] : firstPage);
    firstPage && lastPage && setNumberOfTotalPages(getTotalPages(firstPage, lastPage));
  }, [book?.pages]);

  const pages = routes.includes(window.location.pathname)
    ? book?.pages
    : book?.pages.filter(({ pageNumber }) => !isNil(pageNumber));

  const pagesToDisplay =
    currentPage === DEFAULT_FIRST_PAGE[PageTypes.Pdf]
      ? [getCurrentPageData(pages, true)]
      : getCurrentPageData(pages);

  const PageList = pagesToDisplay?.map(({ id, pageNumber, src }) => {
    return (
      <iframe
        key={id}
        src={src}
        title={`iframe for page ${id}-${pageNumber}`}
        frameBorder={0}
        className={classes.iframe}
        scrolling="no"
      />
    );
  });

  return {
    PageList,
    pagesToDisplay,
  };
};

const useStyles = makeStyles(() => ({
  iframe: {
    backgroundColor: 'transparent',
    width: '100%',
    height: '100%',
  },
  cover: {
    maxWidth: '70%',
    maxHeight: '80vh',
    margin: '20px auto',
    userSelect: 'none',
  },
}));

export default useLetterTeaching;
